import React from 'react';

import { FileOutlined, FilePdfOutlined, FileImageOutlined } from '@ant-design/icons';
import { Table, Tag, Button } from 'antd';
import { useTranslation } from 'react-i18next';

function getFileIcon(contentType) {
  if (contentType === 'application/pdf') return <FilePdfOutlined style={{ color: '#ff4d4f' }} />;
  if (contentType?.startsWith('image/')) return <FileImageOutlined style={{ color: '#1677ff' }} />;
  return <FileOutlined style={{ color: '#888' }} />;
}

function formatFileSize(bytes) {
  if (!bytes) return '-';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/**
 * 揀貨波次附件區塊（唯讀）。
 * 彙整本波次所揀訂單的附件（手動上傳 + 來源匯入批次），標註所屬訂單，僅供下載 / 列印，
 * 不支援上傳或刪除（附件的維護在訂單建單 / 編輯頁進行）。
 */
export default function WaveAttachments({ attachments }) {
  const { t } = useTranslation();

  const columns = [
    {
      title: t('shared.picking_waves.show.attachments.filename'),
      dataIndex: 'filename',
      key: 'filename',
      render: (filename, record) => (
        <span>
          {getFileIcon(record.content_type)}{' '}
          {record.file_url ? (
            <a href={record.file_url} target="_blank" rel="noopener noreferrer">
              {filename}
            </a>
          ) : (
            filename
          )}
          {record.source === 'import' && (
            <Tag color="blue" style={{ marginLeft: 8 }}>
              {t('shared.orders.attachments.source_import')}
            </Tag>
          )}
        </span>
      ),
    },
    {
      title: t('shared.picking_waves.show.attachments.order'),
      dataIndex: 'order_name',
      key: 'order_name',
      width: 180,
    },
    {
      title: t('shared.picking_waves.show.attachments.byte_size'),
      dataIndex: 'byte_size',
      key: 'byte_size',
      width: 100,
      align: 'right',
      render: (bytes) => formatFileSize(bytes),
    },
    {
      title: t('common.table.actions'),
      key: 'actions',
      width: 100,
      render: (_, record) =>
        record.file_url ? (
          <Button type="link" size="small" href={record.file_url} target="_blank" rel="noopener noreferrer">
            {t('shared.picking_waves.show.attachments.download')}
          </Button>
        ) : null,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={attachments || []}
      rowKey={(record) => `${record.source}-${record.order_id}-${record.id}`}
      pagination={false}
      size="small"
      locale={{ emptyText: t('shared.picking_waves.show.attachments.empty') }}
    />
  );
}
